<div class="verify-page">
  <mat-card class="verify-card">

    @if (state === 'verifying') {
      <div class="verify-state">
        <mat-spinner diameter="40"></mat-spinner>
        <h2>Verifying your email…</h2>
        <p>Hang tight, this only takes a second.</p>
      </div>
    }

    @if (state === 'success') {
      <div class="verify-state">
        <mat-icon class="icon success">check_circle</mat-icon>
        <h2>Email verified!</h2>
        <p>{{ message }}</p>
        <p class="hint">Taking you to your dashboard…</p>
      </div>
    }

    @if (state === 'error') {
      <div class="verify-state">
        <mat-icon class="icon error">error</mat-icon>
        <h2>Verification failed</h2>
        <p>{{ message }}</p>

        <form [formGroup]="resendForm" (ngSubmit)="resend()" class="resend-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email address</mat-label>
            <input matInput formControlName="email" placeholder="you@example.com" type="email" />
            <mat-error *ngIf="resendForm.get('email')?.hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="resendForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
          </mat-form-field>

          <button mat-raised-button color="primary" type="submit" [disabled]="!resendForm.valid || resending" class="full-width">
            @if (resending) {
              <mat-spinner diameter="18" class="inline-spinner"></mat-spinner>
            } @else {
              Resend verification link
            }
          </button>
        </form>

        <a routerLink="/landing" class="back-link">Back to login</a>
      </div>
    }

  </mat-card>
</div>
